import { CustomerIO } from "@/components/customer-io";
import FullscreenLoader from "@/components/fullscreen-loader";

import AppInitializer from "@/providers/app-initializer";
import OnboardingWrapper from "@/providers/onboarding-wrapper";
import { PermissionWrapper } from "@/providers/permission-wrapper";
import { CustomRequireActiveTenancyWrapper } from "@/providers/custom-require-active-tenancy-wrapper";
import { Navigate } from "@tanstack/react-router";
import {
  DeploymentInitialized,
  DeploymentInitializing,
  SignedIn,
  SignedOut,
  useSession,
} from "@wacht/tanstack-router";

export function ProtectedWrapper({ children }: { children: React.ReactNode }) {
  return (
    <>
      <DeploymentInitialized>
        <SignedIn>
          <CustomRequireActiveTenancyWrapper>
            <OnboardingWrapper>
              <AppInitializer>
                <PermissionWrapper>
                  <CustomerIO />
                  {children}
                </PermissionWrapper>
              </AppInitializer>
            </OnboardingWrapper>
          </CustomRequireActiveTenancyWrapper>
        </SignedIn>
        <SignedOut>
          <Navigate to="/signin" />
        </SignedOut>
      </DeploymentInitialized>
      <DeploymentInitializing>
        <FullscreenLoader />
      </DeploymentInitializing>
    </>
  );
}
